import { Skeleton } from 'antd';

import * as St from './SkeletonCardAppliance.styles';

const SkeletonCardAppliance = () => (
  <St.Container className="skeleton">
    <Skeleton.Image active rootClassName={St.imgClassName} />
    {[...Array(3).keys()].map((lineId) => (
      <Skeleton.Input
        key={lineId}
        active
        block
        rootClassName={St.lineClassName}
      />
    ))}
    <div style={{ width: '60rem', marginInlineStart: 'auto' }}>
      <Skeleton.Button
        active
        block
        rootClassName={St.btnClassName}
        shape="round"
      />
    </div>
  </St.Container>
);

export default SkeletonCardAppliance;
